@if (enabled) {
  <div>
    @for (rlm of resultListModes; track rlm) {
      <button
        (click)="changeMode.emit(rlm)"
        [id]="'catalog_result-list_btn_change-to-' + rlm"
        [ngClass]="{'text-primary': isActive(rlm)}"
        [title]="'catalog.result_list.mode.' + rlm | transloco"
        mat-icon-button
      >
        <mat-icon>{{ getIcon(rlm) }}</mat-icon>
      </button>
    }
  </div>
}
